<template>
  <b-modal size="lg" id="pulse-goals" hide-header hide-footer @shown="getGoals" @hidden="clearData">
    <b-row>
      <b-col lg="7">
        <div class="text-center mb-2">
          <img src="/img/pulse/pulse-logo-black.png" class="mb-3" style="width: 150px; height: auto;">
          <h3>Annual Goal Calculator</h3>
        </div>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <form class="needs-validation"
                @submit.prevent="handleSubmit(submit)">

            <h5>Do you know your real estate conversions?</h5>
            <base-switch class="mr-1" v-model="form.conversions"></base-switch>

            <div v-if="form.conversions">
              <b-row>
                <b-col md="6">
                  <base-input label="Closed Volume:"
                              labelClasses="h5"
                              type="number"
                              rules="required"
                              name="Closed Volume"
                              prependIcon="fas fa-dollar-sign"
                              v-model="form.closed_volume"
                              placeholder="0">
                  </base-input>
                </b-col>
                <b-col md="6">
                  <base-input label="Closed Units:"
                              labelClasses="h5"
                              rules="required"
                              name="Closed Units"
                              v-model="form.closed_units"
                              placeholder="0">
                  </base-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <base-input label="Total Conversations:"
                              labelClasses="h5"
                              rules="required"
                              name="Closed Units"
                              v-model="form.conversations"
                              placeholder="0">
                  </base-input>
                </b-col>
                <b-col md="6">
                  <base-input label="Total Appointments Held:"
                              labelClasses="h5"
                              rules="required"
                              name="Total Appointments Held"
                              v-model="form.appt_held"
                              placeholder="0">
                  </base-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <base-input label="Total Agreements Signed:"
                              labelClasses="h5"
                              rules="required"
                              name="Total Agreements Signed"
                              v-model="form.agreements_signed"
                              placeholder="0">
                  </base-input>
                </b-col>
                <b-col md="6">
                  <base-input label="Total Ambassadors:"
                              labelClasses="h5"
                              rules="required"
                              name="Total Ambassadors"
                              v-model="form.ambassadors"
                              placeholder="0">
                  </base-input>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <base-input label="My Gross Commission Income (GCI) Goal for this year is:"
                          labelClasses="h5"
                          type="number"
                          rules="required"
                          name="GCI"
                          prependIcon="fas fa-dollar-sign"
                          v-model="form.gci"
                          placeholder="0">
              </base-input>

              <base-input label="My Average Sale Price is: (US National Average is $450,000)"
                          labelClasses="h5"
                          type="number"
                          rules="required"
                          name="Amount"
                          prependIcon="fas fa-dollar-sign"
                          v-model="form.avg_sale_price"
                          placeholder="0"
                          inputClasses="mb-0">
              </base-input>
            </div>

            <base-input label="My Average Commission Rate is: (US National average is 2.8%)"
                        labelClasses="h5"
                        rules="required"
                        name="Amount"
                        appendIcon="fas fa-percent"
                        v-model="form.avg_commission_percent"
                        placeholder="0">
            </base-input>

            <base-button class="pulse-btn" block type="success" native-type="submit">
              Save Annual Goals
            </base-button>
          </form>
        </validation-observer>
      </b-col>
      <b-col lg="5">
        <b-list-group class="mt-3">
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Average Commission:</h4>
            <span class="badge badge-primary badge-pill">{{ commission | currency }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Closed Volume:</h4>
            <span class="badge badge-primary badge-pill">{{ volume | currency }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Closed Units:</h4>
            <span class="badge badge-primary badge-pill">{{ units }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Total Conversations:</h4>
            <span class="badge badge-primary badge-pill">{{ conversations }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Total Appointments Held:</h4>
            <span class="badge badge-primary badge-pill">{{ appointments }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Total Agreements Signed:</h4>
            <span class="badge badge-primary badge-pill">{{ agreements }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Total Ambassadors:</h4>
            <span class="badge badge-primary badge-pill">{{ ambassadors }}</span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  data() {
    return {
      form: {
        id: null,
        year: new Date().getFullYear(),
        gci: 0,
        avg_sale_price: 0,
        avg_commission_percent: 0,
        conversions: false,
        closed_volume: null,
        closed_units: null,
        conversations: null,
        appt_held: null,
        agreements_signed: null,
        ambassadors: null,
      }
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
    commission() {
      if (this.form.conversions) {
        return (this.form.closed_volume / this.form.closed_units) * (this.form.avg_commission_percent / 100);
      } else {
        return this.form.avg_sale_price * (this.form.avg_commission_percent / 100);
      }
    },
    units() {
      if (this.form.conversions) {
        return this.form.closed_units ?? 0;
      } else {
        return this.commission > 0 ? Math.round(this.form.gci / this.commission) : 0;
      }
    },
    conversations() {
      if (this.form.conversions) {
        return this.form.conversations ?? 0;
      } else {
        return (200 * this.units).toFixed();
      }
    },
    appointments() {
      if (this.form.conversions) {
        return this.form.appt_held ?? 0;
      } else {
        return (4 * this.units).toFixed();
      }
    },
    agreements() {
      if (this.form.conversions) {
        return this.form.agreements_signed ?? 0;
      } else {
        return (2 * this.units).toFixed();
      }
    },
    ambassadors() {
      if (this.form.conversions) {
        return this.form.ambassadors ?? 0;
      } else {
        return (6 * this.units).toFixed();
      }
    },
    volume() {
      if (this.form.conversions) {
        return this.form.closed_volume ?? 0;
      } else {
        return (this.form.avg_sale_price * this.units).toFixed();
      }
    }
  },
  methods: {
    getGoals() {
      axios.get(this.userRoute + "/pulse/pulse-annual-goals?year=" + this.form.year)
      .then(response => {
        if (response.data.id) {
          this.form = response.data;
        }
      })
      .catch(error => {
        // 
      });
    },
    submit() {
      if(this.form.id) {
        this.handleUpdate();
      } else {
        this.handleCreate();
      }
    },
    handleCreate() {
      axios.post(this.userRoute + "/pulse/pulse-annual-goals", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$refs.formValidator.reset();
          this.$bvModal.hide('pulse-goals');
          window.location.reload();
        });
      })
      .catch(error => {
        // error
      });
    },
    handleUpdate() {
      axios.patch(this.userRoute + "/pulse/pulse-annual-goals/" + this.form.id, {
        year: this.form.year,
        gci: this.form.gci,
        avg_sale_price: this.form.avg_sale_price,
        avg_commission_percent: this.form.avg_commission_percent,
        conversions: this.form.conversions,
        closed_volume: this.form.closed_volume,
        closed_units: this.form.closed_units,
        conversations: this.form.conversations,
        appt_held: this.form.appt_held,
        agreements_signed: this.form.agreements_signed,
        ambassadors: this.form.ambassadors
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$refs.formValidator.reset();
          this.$bvModal.hide('pulse-goals');
          window.location.reload();
        });
      })
      .catch(error => {
        // error
      });
    },
    clearData() {
      this.form.id = null;
      this.form.year = new Date().getFullYear();
      this.form.gci = 0;
      this.form.avg_sale_price = 0;
      this.form.avg_commission_percent = 0;
    },
  }
};
</script>
<style lang="scss">
.pulse-btn {
  background-color: #DDB143!important;
  border-color: #DDB143!important;
}
</style>